import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import About from '@/pages/home/components/About';
import Services from '@/pages/home/components/Services';
import WhyChooseUs from '@/pages/home/components/WhyChooseUs';
import Contact from '@/pages/home/components/Contact';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen font-body">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <WhyChooseUs />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
